import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Label, Sidebar, Segment, Menu, Modal } from 'semantic-ui-react';
import { INITIAL_STATE } from 'modules/surveys';
import { actions as siteActions } from 'modules/site';
import initMap from './Map';
import SidebarContent from './Sidebar';
import './surveys.css';


class Surveys extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSidebarOpen: true,
            map: null,
            showModal: true
        };
        // TODO: siteName should come from master flcpa json, which is passed to this
        // TODO: components' props.detail, though after componentDidMount... Alternatively, we could set siteName as a
        // TODO: global variable toward the top of this file, and set the value there. That will make it easier to find
        // TODO: and abstract out in the future.
        props.updateSiteState({siteName: 'Florida Conservation Actions Tracker'});

        let map = null
        this.toggleSidebar = this.toggleSidebar.bind(this)
        this.enterListener = (e) => {
            e = e || window.event;
            var keycode = e.which || e.keyCode;
            if (keycode == 13 && e.target.nodeName == 'INPUT' && e.target.type !== 'textarea') {
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                }
                if (e.stopPropagation) {
                    e.stopPropagation();
                } else { // IE
                    e.cancelBubble = true;
                }
                return false;
            }

        }
    }

    componentDidMount() {
        // TODO: Pass center, zoom to initMap. This info should be added to master flcpa json, which is passed to this
        // TODO: components' props.detail, though after componentDidMount...
        const map = initMap();

        // The following corrects a problem with tiles not displaying on load until window has been resized (chrome)
        map._onResize();

        this.map = map
        window.addEventListener('keydown', this.enterListener, true);
    }

    componentWillUnMount() {
        if (this.map) {
            this.map.remove()
        }
        window.removeEventListener('keydown', this.enterListener, true);
    }

    toggleSidebar() {
        this.setState({isSidebarOpen: !this.state.isSidebarOpen})
        this.map.invalidateSize()
    }

    render() {
        const mapContainer = document.getElementById('Map');
        if (mapContainer) {
            if (this.state.isSidebarOpen) {
                mapContainer.classList.remove('closedSidebar');
            } else {
                mapContainer.classList.add('closedSidebar');
            }
            this.map.invalidateSize();
        }

        return (
            <div className="survey" id="App">
                <Sidebar.Pushable as={Segment} height="100%">
                    <Modal
                        closeIcon
                        open={this.state.showModal}
                        onClose={() => this.setState({showModal: false})}
                        style={{top: "35%"}}
                    >
                        <Modal.Header>Welcome to the Conservation Actions Tracker</Modal.Header>
                        <Modal.Content scrolling>
                            <Modal.Description>
                                <div style={{fontSize: "larger"}}>
                                    <p>
                                        The Florida Conservation Actions Tracker is designed to facilitate sharing
                                        information about conservation actions on the landscape: completed, planned, or
                                        in progress. In particular, a major goal is to help identify shared priorities
                                        across organizations and result in better coordination among organizations
                                        responsible for conservation effort across the landscape. Target projects range
                                        from restoration to land acquisition to other land management activities.
                                    </p>
                                </div>
                            </Modal.Description>
                        </Modal.Content>
                    </Modal>
                    <Sidebar
                        as={Menu}
                        animation="push"
                        width="very wide"
                        visible={this.state.isSidebarOpen}
                        icon="labeled"
                        vertical
                    >
                        <SidebarContent
                            detail={this.props.detail}
                            list={this.props.list}
                            map={this.map}
                        />
                    </Sidebar>
                    <Sidebar.Pusher id="MapContainer" height="100%">
                        <Label
                            as="a"
                            className={classNames({sidebarTab: true, openSidebar: this.state.isSidebarOpen})}
                            id="rotate-90"
                            color="grey"
                            onClick={this.toggleSidebar}
                        >
                            {/*TODO: "Conservation Actions" should also come from master flcpa json*/}
                            <h3>Conservation Actions</h3>
                        </Label>
                        <div id="Map" />
                    </Sidebar.Pusher>
                </Sidebar.Pushable>
            </div>
        );
    }
}

Surveys.propTypes = {
    detail: PropTypes.shape({
        id: PropTypes.string,
        slug: PropTypes.string,
        metaFields: PropTypes.arrayOf(PropTypes.object)
    }),
    list: PropTypes.arrayOf(PropTypes.object)
};

Surveys.defaultProps = {
    detail: {},
    list: []
};

const mapStateToProps = state => state.get('surveys', INITIAL_STATE).toJS();

export default connect(mapStateToProps, {updateSiteState: siteActions.updateSiteState})(Surveys);



// WEBPACK FOOTER //
// ./source/containers/Surveys/index.jsx